<div class="w-full h-full" #mainDiv>
  <div id="globalMap"></div>
  <div class="map-overlay" *ngIf="mapIsLoading" [@fadeInOut]>
    <div class="flex justify-content-center align-items-center h-full">
      <div class="lds-dual-ring"></div>
    </div>
  </div>
  <p-sidebar [(visible)]="displayDetails" [appendTo]="mainDiv" [modal]="false" styleClass="h-full lg:h-25rem"
    position="bottom">
    <app-map-machine-details *ngIf="detailsMode === 'machine'" [machineUuid]="machineDetailsUuid">
    </app-map-machine-details>
    <app-map-cluster-details *ngIf="detailsMode === 'cluster'" [machineUuids]="machineDetailsUuids"
      (onMachineSelected)="showMachineDetails($event, null);"></app-map-cluster-details>
  </p-sidebar>
</div>
<div class="hidden">
  <div class="mapboxgl-ctrl mapboxgl-ctrl-group" id="map-layer-control-filters">
    <button [style.backgroundColor]="'white'" [style.color]="'black'" (click)="toggleFilters(); displayDetails=false"
      pRipple class="hover:bg-black-alpha-10" type="button">
      <i class="pi pi-filter" style="font-size: 18px;"></i>
    </button>
  </div>
</div>
<div *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')" class="hidden">
  <div class="mapboxgl-ctrl mapboxgl-ctrl-group" id="map-layer-control-clipboard">
    <button [style.backgroundColor]="'white'" [style.color]="'black'" pRipple [cdkCopyToClipboard]="gisMachinesJson()"
      (click)="commonMessagesService.showCopiedToClipboardMessage()" class="hover:bg-black-alpha-10" type="button">
      <i class="pi pi-clone" style="font-size: 18px;"></i>
    </button>
  </div>
</div>


<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="alias">{{'attribute.alias' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.alias" [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()" appAutoFocus pInputText class="w-full" id="alias"
          type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="serialNumber">{{'attribute.serialNumber' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.serialNumber" (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText class="w-full" id="serialNumber" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="eui">{{'attribute.eui' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.eui" (keyup.enter)="filtersVisible = false; applyFilters()"
               pInputText class="w-full" id="eui" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="simNumber">{{'attribute.simNumber' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.simNumber" (keyup.enter)="filtersVisible = false; applyFilters()"
               pInputText class="w-full" id="simNumber" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.state' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.isPoweredOn" [label]="'misc.poweredOnAndOff' | transloco"
                         name="state" [value]=null></p-radioButton>
        </div>
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.isPoweredOn" [label]="'misc.poweredOnOnly' | transloco" name="state"
                         value="true"></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton [(ngModel)]="currentFilters.isPoweredOn" [label]="'misc.poweredOffOnly' | transloco" name="state"
                         value="false"></p-radioButton>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.connection' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.isOn" [label]="'misc.connectedDisconnected' | transloco"
            name="connection" [value]=null></p-radioButton>
        </div>
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.isOn" [label]="'misc.connectedOnly' | transloco" name="connection"
            value="true"></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton [(ngModel)]="currentFilters.isOn" [label]="'misc.disconnectedOnly' | transloco" name="connection"
            value="false"></p-radioButton>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organization">{{'model.organization' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-treeSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco" display="chip"
          appendTo="body" [propagateSelectionUp]="false" [propagateSelectionDown]="false" [options]="hierarchy"
          [metaKeySelection]="false" selectionMode="checkbox" id="organization"></p-treeSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organizationCode">{{'model.organizationCode' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
                       [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="organizationCodes"
                       id="organizationCode"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="model">{{'attribute.model' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.machineModelUuids" [placeholder]="'select.generic' | transloco"
          [filter]="true" filterBy="modelName" display="chip" styleClass="w-full" appendTo="body" [options]="models"
          id="model" optionLabel="modelName" optionValue="machineModelUuid">
          <ng-template let-model pTemplate="item">
            <div class="flex align-items-center">
              <div style="width:30px;">
                <img [src]="model.image" [alt]="model.modelName" style="max-height: 30px;max-width: 100%;" />
              </div>
              <p class="mb-0 ml-1 p-0">{{model.modelName}}</p>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="country">{{'attribute.country' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.countries" [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="countries"
          (onChange)="onCountryChange($event)" id="country" optionLabel="name" optionValue="name"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="state">{{'attribute.province' | transloco}}/{{'attribute.state' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.states" [placeholder]="'select.generic' | transloco" [filter]="true"
          display="chip" styleClass="w-full" appendTo="body" [options]="filteredStates" [disabled]="isStateDisabled"
          (onChange)="onStateChange($event)" id="state" optionLabel="name" optionValue="name"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="locality">{{'attribute.locality' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.localities" [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="filteredLocalities"
          [disabled]="isLocalityDisabled" id="locality" optionLabel="name" optionValue="name"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="communicationType">{{'attribute.communicationType' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-dropdown [(ngModel)]="currentFilters.communicationType" [placeholder]="'select.generic' | transloco"
                    styleClass="w-full" appendTo="body" [options]="communicationTypes" [showClear]="true"
                    [autoDisplayFirst]="false" id="communicationType" optionLabel="label" optionValue="value">
        </p-dropdown>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.deletion' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.deleted" [label]="'misc.deletedOnly' | transloco" name="deleted"
                         [value]="true"></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton [(ngModel)]="currentFilters.deleted" [label]="'misc.notDeletedOnly' | transloco" name="deleted"
                         [value]="false"></p-radioButton>
        </div>
      </div>
    </div>
    <div *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')" class="col-12">
      <div class="col-12 form-field">
        <label for="group">{{'attribute.group' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.machineGroupsUuids" [placeholder]="'select.generic' | transloco"
          [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body" [options]="groups"
          id="group" optionLabel="name" optionValue="machineGroupUuid">
          <ng-template let-group pTemplate="item">
            <div class="flex align-items-center">
              <p-tag value="{{group.name}}" class="group-tag"
                [style]="{'background': group.color, 'color': adjustTextColor(group.color)}"></p-tag>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div *ngIf="authGuard.hasPermission('PERMISSION_VIEW_ALARMS')" class="col-12">
      <div class="col-12 form-field">
        <label for="alarm">{{'misc.alarm' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.alarmsDefinitionUuids" [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="alarms" id="alarm"
          optionLabel="name" optionValue="alarmDefinitionUuid"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <p-button [label]="'common.filter' | transloco" [disabled]="!(
            currentFilters.alias ||
            currentFilters.serialNumber ||
            currentFilters.eui ||
            currentFilters.simNumber ||
            currentFilters.isOn != null ||
            currentFilters.isPoweredOn != null ||
            organizations ||
            currentFilters.machineModelUuids ||
            currentFilters.countries ||
            currentFilters.states ||
            currentFilters.localities ||
            currentFilters.deleted != null ||
            currentFilters.machineGroupsUuids ||
            currentFilters.alarmsDefinitionUuids
          )" (onClick)="filtersVisible = false; applyFilters()" styleClass="p-button-primary mx-2 mt-2" type="button">
      </p-button>
      <p-button [label]="'common.clear' | transloco" (click)="resetFilters(); filtersVisible = false; applyFilters()"
        styleClass="p-button-danger" type="button"></p-button>
    </div>
  </div>
</p-sidebar>
